import Breadcrumb from "@/components/feature/Breadcrumb";
import CatalogView from "@/components/feature/CatalogView";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { movies } from "@/lib/content";

export default function Movies() {
  useDocumentMeta({
    title: "电影 - 夜无疆影视大全",
    description:
      "精选最新动作、爱情、科幻电影资源，夜无疆为您提供全面的电影资讯和观看指南，支持按类型、地区与年份筛选。",
    keywords: "电影,最新电影,动作电影,科幻电影,爱情电影,电影推荐,夜无疆电影",
  });

  return (
    <div className="w-full animate-fadeIn">
      <div className="border-b border-background-200/70 bg-background-100/40 px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "电影" }]} />
        <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">电影</h1>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base">
          汇聚最新与经典电影作品，覆盖动作、科幻、爱情、悬疑、犯罪、冒险、剧情与动画等类型。你可以按类型、地区与年份组合筛选，并按最新、评分或热度排序，快速找到想看的那一部。
        </p>
      </div>

      <div className="w-full px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <CatalogView items={movies} emptyText="暂无符合筛选条件的电影" />
      </div>
    </div>
  );
}